export default __webpack_public_path__ + "7423733d87900385bf711058e119c00a.svg";